import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type RlToastType = 'success' | 'warning' | 'info' | 'question';

export interface RlToast {
  text: string;
  type: RlToastType;
}

@Injectable({
  providedIn: 'root'
})
export class RlToastService {
  readonly toast$ = new BehaviorSubject<RlToast | null>(null);
  private hideTimer: ReturnType<typeof setTimeout> | null = null;

  show(text: string, type: RlToastType = 'success', durationMs = 3500): void {
    if (!text) {
      return;
    }
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
    this.toast$.next({ text, type });
    this.hideTimer = setTimeout(() => {
      this.toast$.next(null);
      this.hideTimer = null;
    }, durationMs);
  }

  success(text: string, durationMs = 3500): void {
    this.show(text, 'success', durationMs);
  }

  warning(text: string, durationMs = 2500): void {
    this.show(text, 'warning', durationMs);
  }

  info(text: string, durationMs = 2000): void {
    this.show(text, 'info', durationMs);
  }

  dismiss(): void {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
    this.toast$.next(null);
  }
}
